/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ApolloError } from 'apollo-client';

import { PageNotification } from '@coursera/cds-core';

import type { SubmissionQuestionBase } from 'bundles/grading/api/types';
import LoadingSpinner from 'bundles/grading/components/common/LoadingSpinner';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import QuestionSummary from 'bundles/grading/components/staff-graded-assignments/middle-panel/QuestionSummary';

import _t from 'i18n!nls/grading';

const styles = {
  spinnerContainer: () => css`
    /* show spinner in the middle of the non-zero-height container, otherwise there's a scrollbar */
    height: var(--cds-spacing-1400);
  `,
  errorContainer: () => css`
    margin-top: var(--cds-spacing-100);
  `,
};

type Props = {
  loading: boolean;
  error?: ApolloError;
  questions?: SubmissionQuestionBase[] | null;
};

const AttemptReview: React.FC<Props> = ({ loading, error, questions }) => {
  if (loading) {
    return (
      <div css={styles.spinnerContainer} data-testid="loading-spinner">
        <LoadingSpinner centered />
      </div>
    );
  }

  if (error || !questions || questions.length === 0) {
    return (
      <PageNotification css={styles.errorContainer} severity="error" title={_t('Something went wrong')}>
        {_t('Something went wrong while loading data. Please try to close and open the dialog again.')}
      </PageNotification>
    );
  }

  return <QuestionSummary questions={questions} />;
};

export default AttemptReview;
